import styled from 'styled-components';

export const DeerFooterContainer = styled.div`
  background: white;
  border: 1px solid #eaeaea;
  padding: 1rem 1.5rem;
  position: fixed;
  bottom: 0;
  text-align: right;
  button {
    padding: 0.5rem 2.5rem;
  }

  width: calc(100vw - 367px);
  position: fixed;
  left: 367px;
`;
